module.exports = "pegasus_template/assets/theme4/google-icon-1.png";